/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Use_Land_Skin_ContentInputs */

const en_dialog_use_land_skin_content = /** @type {(inputs: Dialog_Use_Land_Skin_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You’ve unlocked a new land style! Head to Settings to try it out.`)
};

const ar_dialog_use_land_skin_content = /** @type {(inputs: Dialog_Use_Land_Skin_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لقد فتحت نمط أرض جديدًا! انتقل إلى الإعدادات لتجربته.`)
};

const de_dialog_use_land_skin_content = /** @type {(inputs: Dialog_Use_Land_Skin_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast einen neuen Land-Stil freigeschaltet! Probiere ihn in den Einstellungen aus.`)
};

const es_dialog_use_land_skin_content = /** @type {(inputs: Dialog_Use_Land_Skin_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Has desbloqueado un nuevo estilo de terreno! Ve a Ajustes para probarlo.`)
};

const fr_dialog_use_land_skin_content = /** @type {(inputs: Dialog_Use_Land_Skin_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous avez débloqué un nouveau style de sol ! Rendez-vous dans les Paramètres pour l’essayer.`)
};

const it_dialog_use_land_skin_content = /** @type {(inputs: Dialog_Use_Land_Skin_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai sbloccato un nuovo stile del terreno! Vai nelle Impostazioni per provarlo.`)
};

const ja_dialog_use_land_skin_content = /** @type {(inputs: Dialog_Use_Land_Skin_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいランドスタイルをアンロックしました！設定画面で試してみましょう。`)
};

const ko_dialog_use_land_skin_content = /** @type {(inputs: Dialog_Use_Land_Skin_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`새 랜드 스타일을 잠금 해제했어요! 설정에서 적용해 보세요.`)
};

const pt_br_dialog_use_land_skin_content = /** @type {(inputs: Dialog_Use_Land_Skin_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você desbloqueou um novo estilo de terreno! Vá até as Configurações para experimentar.`)
};

const ru_dialog_use_land_skin_content = /** @type {(inputs: Dialog_Use_Land_Skin_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы разблокировали новый стиль земли! Перейдите в Настройки, чтобы попробовать его.`)
};

const th_dialog_use_land_skin_content = /** @type {(inputs: Dialog_Use_Land_Skin_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณปลดล็อกสไตล์พื้นดินใหม่แล้ว! ไปที่การตั้งค่าเพื่อลองใช้ได้เลย`)
};

const tr_dialog_use_land_skin_content = /** @type {(inputs: Dialog_Use_Land_Skin_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yeni bir arazi türünün kilidini açtın! Denemek için Ayarlar’a git.`)
};

const zh_cn_dialog_use_land_skin_content = /** @type {(inputs: Dialog_Use_Land_Skin_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成功解锁了新的土地皮肤！前往设置页面试试看吧`)
};

const zh_tw_dialog_use_land_skin_content = /** @type {(inputs: Dialog_Use_Land_Skin_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成功解鎖了新的土地造型！前往設定頁面用看看吧`)
};

/**
* | output |
* | --- |
* | "You’ve unlocked a new land style! Head to Settings to try it out." |
*
* @param {Dialog_Use_Land_Skin_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_use_land_skin_content = /** @type {((inputs?: Dialog_Use_Land_Skin_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Use_Land_Skin_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_use_land_skin_content(inputs)
	if (locale === "ar") return ar_dialog_use_land_skin_content(inputs)
	if (locale === "de") return de_dialog_use_land_skin_content(inputs)
	if (locale === "es") return es_dialog_use_land_skin_content(inputs)
	if (locale === "fr") return fr_dialog_use_land_skin_content(inputs)
	if (locale === "it") return it_dialog_use_land_skin_content(inputs)
	if (locale === "ja") return ja_dialog_use_land_skin_content(inputs)
	if (locale === "ko") return ko_dialog_use_land_skin_content(inputs)
	if (locale === "pt_br") return pt_br_dialog_use_land_skin_content(inputs)
	if (locale === "ru") return ru_dialog_use_land_skin_content(inputs)
	if (locale === "th") return th_dialog_use_land_skin_content(inputs)
	if (locale === "tr") return tr_dialog_use_land_skin_content(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_use_land_skin_content(inputs)
	return zh_tw_dialog_use_land_skin_content(inputs)
});